import { render, staticRenderFns } from "./ProfileTypeIcon.vue?vue&type=template&id=18fe72f1&"
import script from "./ProfileTypeIcon.vue?vue&type=script&lang=js&"
export * from "./ProfileTypeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports